import React from "react";
import style from "./index.module.scss";
import { Icon, Menu, message, Modal, Spin, Tooltip } from "antd";
import {
    ActivityTaskListItem,
    deleteGroupActivityTaskInfo
} from "service/group";
import {
    emptyFormAtom,
    ShowConfirmAtom,
    StepStateAtom,
    TouchedAtom
} from "../../../../store";
import { useAtomValue, useSetAtom } from "jotai";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import SubmitError from "components/SubmitError";

interface TaskListMenuProps {
    list: ActivityTaskListItem[]; //任务list
    loading: boolean;
    taskId: number; //任务id
    onChangeTaskId: (val: number) => void; //改变当前任务id
    onChangeTargetTaskId?: (val: number) => void; //改变当前任务id
    preview?: boolean;
    onRefresh?: () => void; //刷新列表
}
export default function TaskListMenu({
    list,
    loading,
    taskId,
    onChangeTaskId,
    onChangeTargetTaskId,
    preview = false,
    onRefresh
}: TaskListMenuProps) {
    const setEmptyForm = useSetAtom(emptyFormAtom);
    const touched = useAtomValue(TouchedAtom);
    const setShowConfirm = useSetAtom(ShowConfirmAtom);
    const setStepState = useSetAtom(StepStateAtom);

    const onSelect = (key: string) => {
        onChangeTargetTaskId?.(Number(key));
        setStepState("current");

        if (touched) {
            setShowConfirm(true);
            return;
        }
        onChangeTaskId(Number(key));
        setEmptyForm(false);
    };

    const onDelete = (id: number) => {
        Modal.confirm({
            title: `确认删除任务吗？`,
            onOk: async () => {
                try {
                    await deleteGroupActivityTaskInfo(id);
                    await onRefresh?.();
                    await onChangeTargetTaskId?.(-1);
                    message.success("删除成功");
                } catch (e) {
                    ResultMessage.error(
                        <SubmitError
                            title="删除失败"
                            content={errorMessage(e)}
                        />,
                        { width: 300 }
                    );
                }
            }
        });
    };

    return (
        <div className={style.root}>
            <div className={style.listName}>任务列表</div>
            <Spin spinning={loading}>
                {list?.length !== 0 && (
                    <Menu
                        selectedKeys={[taskId.toString()]}
                        onSelect={item => onSelect(item.key)}>
                        {list?.map(item => (
                            <Menu.Item key={item.id} className={style.menuItem}>
                                <Tooltip
                                    title={item.taskName}
                                    placement="topLeft">
                                    <div className={style.title}>
                                        {item.taskName}
                                        {!preview && (
                                            <Icon
                                                type="close"
                                                className={style.icon}
                                                onClick={() =>
                                                    onDelete(item.id)
                                                }
                                            />
                                        )}
                                        &nbsp;&nbsp;({item.score}分)
                                    </div>
                                </Tooltip>
                            </Menu.Item>
                        ))}
                    </Menu>
                )}

                {list?.length === 0 && (
                    <CustomEmpty
                        description="暂无数据"
                        style={{ margin: "100px 0" }}
                    />
                )}
            </Spin>
        </div>
    );
}
